import * as React from "react"
import { cva, type VariantProps } from "class-variance-authority"
import { cn } from "@/lib/utils"

const pinVariants = cva("relative inline-flex items-center justify-center shrink-0 size-4", {
  variants: {
    variant: {
      default: "text-primary",
      success: "text-success",
      warning: "text-warning",
      destructive: "text-destructive",
      info: "text-blue-500",
    },
    size: {
      default: "h-2 w-2",
      sm: "h-1 w-1",
      lg: "h-3 w-3",
    },
  },
  defaultVariants: {
    variant: "default",
    size: "default",
  },
})

interface PinProps
  extends React.HTMLAttributes<HTMLSpanElement>,
    VariantProps<typeof pinVariants> {
  ping?: boolean
}

const Pin = React.forwardRef<HTMLSpanElement, PinProps>(
  ({ className, variant, size, ping = true, ...props }, ref) => {
    return (
      <span
        ref={ref}
        className={cn(pinVariants({ variant, size, className }))}
        {...props}
      >
        {ping && (
          <span
            className={cn(
              "absolute inline-flex h-full w-full animate-ping rounded-full opacity-75",
              {
                "bg-primary": variant === "default",
                "bg-success": variant === "success",
                "bg-warning": variant === "warning",
                "bg-destructive": variant === "destructive",
                "bg-blue-500": variant === "info",
              }
            )}
          />
        )}
        <span
          className={cn("relative inline-flex h-full w-full rounded-full", {
            "bg-primary": variant === "default",
            "bg-success": variant === "success",
            "bg-warning": variant === "warning",
            "bg-destructive": variant === "destructive",
            "bg-blue-500": variant === "info",
          })}
        />
      </span>
    )
  }
)
Pin.displayName = "Pin"

export { Pin, pinVariants }
